/* eslint-disable no-underscore-dangle */
type WindowType = Window &
  typeof globalThis & {
    __LIBRARYITEMSTORE__: {
      get: (id: string) => {
        renderedSvg: string;
        rendered: string;
        value: string;
      };
      _data: Record<
        string,
        {
          renderedSvg: string;
          rendered: string;
          value: string;
        }
      >;
    };
  };

const getLibraryItems = () => {
  const libraryItems: Record<string, string> = {};
  const data = (window as WindowType).__LIBRARYITEMSTORE__._data;
  Object.keys(data).forEach((id) => {
    const storeItem = (window as WindowType).__LIBRARYITEMSTORE__.get(id);
    libraryItems[id] =
      storeItem?.renderedSvg || storeItem?.rendered || storeItem?.value;
  });
  return libraryItems;
};

export default getLibraryItems;
